import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Stepper } from './Stepper';
import { Theme } from '@theme/base';
import { BookingSteps, toursBookingSteps, toursBookingStepsToPagesMapping } from '@model/common';
import { TripTypes } from '@model/common/tours/trip-types';
import { getIsTourSearchTypeByType, getTourLandingSearch } from '@state/slices/search/tours';
import { navigateBack } from '@state/basket';

export interface ToursStepperContainerProps {
  theme?: Theme;
  testId?: string;
  currentStep: BookingSteps;
  isGhosting?: boolean;
  tripType: TripTypes;
}

export const ToursStepperContainer = ({ currentStep, testId, isGhosting, tripType }: ToursStepperContainerProps) => {
  const dispatch = useDispatch();
  const isTourSearch = useSelector(getIsTourSearchTypeByType(tripType));
  const isTourLandingSearch = useSelector(getTourLandingSearch);
  const steps = toursBookingSteps(isTourSearch, isTourLandingSearch);
  const handleOnClick = async (step: BookingSteps) => {
    const newStep = toursBookingStepsToPagesMapping[step];
    dispatch(navigateBack(newStep));
  };
  const activeStep = steps.indexOf(currentStep);

  return (
    <Stepper testId={testId} activeStep={activeStep} onClick={!isGhosting ? handleOnClick : () => {}} steps={steps} />
  );
};
